import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Game } from '../enum/game.enum';
import { NavigationEnd, Router } from '@angular/router';
import { Route } from '../enum/route.enum';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RouterService {
  private router = inject(Router);
  private game: Game | undefined = undefined;
  private showNavigation: WritableSignal<boolean> = signal(false);

  public init(game: Game): void {
    if (!this.game) {
      this.game = game;
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          const route = event.url.substring(1).split('?')[0];
          this.setRouteNavigation(route.endsWith(Route.LOGIN) || route.endsWith(Route.CALLBACK));
        });
    }
  }

  public navigateTo(route: string): void {
    void this.router.navigate([this.getBaseUrl(), route]);
  }

  public getCallbackRoute(): string {
    return this.router.createUrlTree([this.getBaseUrl(), Route.CALLBACK]).toString();
  }

  public getImprintRoute(): string {
    return this.router.createUrlTree([this.getBaseUrl(), Route.IMPRINT]).toString();
  }

  public getLoginRoute(): string {
    return this.router.createUrlTree([this.getBaseUrl(), Route.LOGIN]).toString();
  }

  public getBaseUrl(): string {
    return Game.GANDALF !== this.game ? this.game?.toString() || '' : '';
  }

  public hasNavigation(): Signal<boolean> {
    return computed(() => this.showNavigation());
  }

  private setRouteNavigation(hideNavigation: boolean): void {
    this.showNavigation.set(!hideNavigation);
  }
}
